import { minutesToPercent, selectedSegments } from "../../../../components/RRule/timeline-range.js";
import { OCCURRENCE_UI } from "./index.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/OccurrenceTrackLane.tsx
function OccurrenceTrackLane({ occurrence, periodDurationMin, periodFromMin, periodToMin, relativeDurationMinutes, relativeFromStartMinutes, segments }) {
	const { Track } = OCCURRENCE_UI[occurrence.type];
	return /* @__PURE__ */ jsxs("div", {
		className: "relative h-[1lh] w-full",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "border-text-subtle bg-surface-strong absolute inset-0 overflow-hidden rounded-full border",
			children: [selectedSegments(periodFromMin, periodToMin, periodDurationMin).map((segment) => /* @__PURE__ */ jsx("div", {
				className: "bg-main/12.5 absolute top-0 h-full",
				style: {
					left: `${minutesToPercent(segment.start)}%`,
					width: `${minutesToPercent(segment.end - segment.start)}%`
				}
			}, `${segment.start}-${segment.end}`)), /* @__PURE__ */ jsx("div", { className: "bg-neutral absolute top-0 left-1/2 h-full w-px" })]
		}), /* @__PURE__ */ jsx(Track, {
			occurrence,
			periodDurationMin,
			periodFromMin,
			periodToMin,
			relativeDurationMinutes,
			relativeFromStartMinutes,
			segments
		})]
	});
}
//#endregion
export { OccurrenceTrackLane };

//# sourceMappingURL=OccurrenceTrackLane.js.map